/*************************************
 *
 * 网易云 IM 配置文件
 *
 *************************************/

const nim = {
  'debug': true,
  'db': false,
  'appKey': 'd5c32a67a98527adbb37b6212a92ece2'
}

export default nim



// WEBPACK FOOTER //
// ./src/config/modules/nim.js